<template>
<div class="loader">

    <sui-dimmer :active="this.$store.state.loading">
      <sui-loader>Veuilez patienter...</sui-loader>
    </sui-dimmer>
    
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>